import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SxSecurityService } from '../infrastructure/services/sxSecurity.service';
import { AlertService } from '../infrastructure/services/alert.service';
import { RememberMeService } from '../infrastructure/services/rememberme.service';
import { Translator } from 'angular-translator';
import { SxContextService } from '../infrastructure/services/sxContext.service';

@Component({
  selector: 'login-soc',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  esperandoRespuesta = false;
  rememberMe = false;
  email: string;
  password: string;
  lang: string;
  rol: string;
  errors = {
    email: null,
    password: null,
    server: null,
  };

  constructor(private router: Router,
              private sxSecurity: SxSecurityService,
              private sxContextService: SxContextService,
              private rememberMeService: RememberMeService,
              private translator: Translator,
              private sxAlert: AlertService) { }

  ngOnInit(): void {

    // Si el usuario ya esta logueado, proceder hacia la Home
    this.sxSecurity.isLoggedIn().then(resLogin => 
      {
        if(resLogin)
        { 

      // Si tengo un sistema por defecto, redirecciono directamente a la home
      if (this.sxContextService.existeContexto()) {
        this.router.navigate(['/soc', this.sxContextService.getContexto()]);
        return;
      }

      this.router.navigate(['/soc']);
      return;
    }
  });

    // Si Recordarme fue seleccionado anteriormente
    // this.rememberMe = this.rememberMeService.isRememberMeActive();
    // if (this.rememberMe) {
    //   const credencialesGuardadas = this.rememberMeService.get();
    //   this.email = credencialesGuardadas.username;
    //   this.password = credencialesGuardadas.password;
    // }
  }

  ingresar() {
    if (!this.credencialesValidas()) {
      return;
    }

    // sets the language string
    this.lang = <string>this.translator.instant('LANG');

    this.esperandoRespuesta = true;
    this.sxSecurity.login(this.email, this.password,this.lang,this.rol, this.rememberMe)
      .then(() => {
        this.esperandoRespuesta = false;
        // this.manejarRememberMe();

        // Si tengo un sistema por defecto, redirecciono directamente a la home
        if (this.sxContextService.existeContexto()) {
          this.router.navigate(['/soc', this.sxContextService.getContexto()]);
          return;
        }

        this.router.navigate(['/soc']);
      })
      .catch(err => {
        this.esperandoRespuesta = false;
        this.mostrarErrorDelServer(err);
      });
  }

  private credencialesValidas() {
    this.resetearErrores();
    let esValido = true;

    if (!this.email || this.email.length === 0) {
      this.errors.email = 'USUARIO_VACIO';
      esValido = false;
    }

    if (!this.password || this.password.length === 0) {
      this.errors.password = 'CONTRASEÑA_VACIA';
      esValido = false;
    }

    return esValido;
  }

  private resetearErrores() {
    this.errors = {
      email: null,
      password: null,
      server: null,
    };
  }

  private mostrarErrorDelServer(err) {
    if (err.errors && err.errors[0]) {
      this.errors.server = err.errors[0].errorMessage;
    }
  }

  /**
   * Si Recordarme esta checkeado entonces
   * guardamos las credenciales en LocalStorage,
   * sino, no las guardamos y removemos la existente
   */
  // private manejarRememberMe() {
  //   if (this.rememberMe) {
  //     this.rememberMeService.set({
  //       username: this.email,
  //       password: this.password,
  //     });
  //     return;
  //   }

  //   this.rememberMeService.remove();
  // }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/login.component.ts